var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Stack, Text } from "native-base";
import Tag from "../../atoms/Tag";
const SimpleListItem = (_a) => {
    var _b;
    var { label, accessory, content, withTag } = _a, rest = __rest(_a, ["label", "accessory", "content", "withTag"]);
    return (_jsxs(Stack, Object.assign({ direction: {
            base: "row",
            md: "column",
        }, justifyContent: "space-between", alignItems: {
            base: "center",
            md: "flex-start",
        }, bgColor: "white", borderBottomColor: "gray.100", borderBottomWidth: 1, borderBottomStyle: "solid", px: 4, py: 4.5, width: "full" }, rest, { children: [_jsxs(Text, Object.assign({ color: "gray.600", fontSize: "sm", mb: {
                    base: 0,
                    md: 2,
                }, display: "flex", alignItems: "center", maxWidth: {
                    base: "full",
                    sm: "1/2",
                } }, { children: [label, " ", accessory] })), withTag ? (_jsx(Stack, Object.assign({ fontFamily: "Inter", fontSize: "sm", fontWeight: "medium", flex: 1, mr: {
                    base: 0,
                    md: 3,
                }, direction: "row", flexWrap: "wrap", justifyContent: {
                    base: "flex-end",
                    md: "flex-start",
                }, space: 1 }, { children: _jsx(Tag, { children: content }) }))) : ((_b = (_jsx(Text, Object.assign({ textAlign: { base: "right", md: "left" } }, { children: content })))) !== null && _b !== void 0 ? _b : _jsx(Text, { children: "-" }))] })));
};
export default SimpleListItem;
